import { Link } from "react-router-dom";
import { BellRing, Shirt } from "lucide-react";
import { useCountdown, pad } from "@/lib/launch";
import { openRemind } from "./RemindForm";

const ROW = "flex items-center justify-center gap-3 h-8 px-3 text-[11px] sm:text-xs font-bold uppercase tracking-[0.08em] sm:tracking-[0.14em] whitespace-nowrap";

export const LaunchBar = () => {
  const { done, d, h, m, s } = useCountdown();
  return (
    <div data-testid="announcement-bar" className={`text-white ${done ? "bg-[#FF5A5F]" : "bg-[#1B1530]"}`}>
      <div className={ROW}>
        {done ? (
          <Link to="/build?size=12" data-testid="announcement-live" className="hover:underline">Now available · Shop now</Link>
        ) : (
          <>
            <Link to="/shop" className="hover:text-[#FFB21A] transition-colors">Drops in <span data-testid="announcement-countdown" className="tabular-nums text-[#FFB21A]">{d}d {pad(h)}:{pad(m)}:{pad(s)}</span>
              <span className="hidden md:inline"> · Oct 16, 10am AST / 9am EST</span></Link>
            <button type="button" data-testid="announcement-remind-button" onClick={openRemind}
              className="inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full bg-white/15 hover:bg-[#FFB21A] hover:text-[#1B1530] transition-colors">
              <BellRing className="h-3 w-3" /> Remind me
            </button>
          </>
        )}
      </div>
      <p data-testid="announcement-tee" className="flex items-center justify-center gap-1.5 h-5 bg-[#FFB21A] text-[#1B1530] text-[11px] font-bold tracking-wide">
        <Shirt className="h-3 w-3" /> First 5 orders get a free exclusive shirt
      </p>
    </div>
  );
};
